import { Footer } from "alpha-ui";

const AppFooter = () => {
  return (
    <Footer
      links={{
        quickLinks: [{ id: 4, title: "Sitemap", to: "/sitemap" }],
      }}
        style={{ paddingTop: '80px' }}
    />
  );
};

export default AppFooter;